<template>
 <b-container align="center" justify="center" >
   <b-row>
     <b-col>
        YOLO Activity<br/>
        
        <b-btn color="success" class="mt-4" style="width: 200px" @click="openX">Spawn Activity - X</b-btn>
        <b-btn   color="success" class="mt-4" style="width: 200px" @click="open">Spawn Activity</b-btn>
        <b-btn   color="success" class="mt-4" style="width: 200px" @click="close">Close me</b-btn>
        <b-input
            v-model="input" 
            label="put something" 
            required
            ></b-input>

        Result from child {{ result }}    
      <br/>
        stringProp =  {{ stringProp }}
      <br/>
        numProp = {{ numProp }}
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        YOLO<br/>
        YOLO<br/>

       Permissions:<br/>
       <div v-if="permissions.TEST_A">You have Test_A </div>
       <div v-if="permissions.TEST_B">You have Test_b </div>
       <div v-if="permissions.SUPERUSER">You have SUPERUSER </div>
     </b-col>
   </b-row>
</b-container>
</template>


<script>
import Activity from "@/activity/Activity";
import  ActivityManager from "../ActivityManager";
import  SampleActivityX from "./SampleActivityX";
import  SampleActivity from "./SampleActivity";
import PermissionsSet from "@/server/PermissionsSet";
import Perms from "@/server/Perms";

export default  {
  name: "SampleActivity",

  
  mounted() {
     console.log("Hello from activity mounted with props:" + this.stringProp + "; " + this.numProp);     
  },
  created() {
     console.log("Hello from activity created ");
  },


  methods: {
  ... Activity.methods,
  
  getTitle(){
    return $tr("simpleActivity","Simple Activity");
  },

  getTitleIcon(){
    return "https://avatars.dicebear.com/v2/identicon/2345.svg";
  },

  canClose(){
    return true; //DialogManager.yesNo("Can I close", "It's serious question");
  },
  beforeClose(){
      this.setResult(this.input);
  },

  hello(){
    // console.log("Hello from activity");
  },

  async open(){
    let activity =  ActivityManager.showActivity(SampleActivity);
    let result = await activity.getResult();
    if(result != null){
      this.result = result;
    }
  },

  async openX(){
    let result = await (await ActivityManager.showActivity(SampleActivityX)).getResult();
    if(result != null){
      this.result = result;
    }
  }


  },

  props: {stringProp:String, numProp:String},

  data: function() {
    return {
      permissions: new PermissionsSet(),
      input: "",
      result: "",
      items: [{a:1}, {a:2}, {a:3}, {a:4}, {a:5},{a:1}, {a:2}, {a:3}, {a:4}, {a:5},{a:1}, {a:2}, {a:3}, {a:4}, {a:5}]
      
    };
  }
};


</script>